module.exports = __webpack_public_path__ + "assets/img/00061.97be73e6.png";